import React, { useEffect, useState } from "react";
import Settings from "./Settings";
import { useDispatch, useSelector } from "react-redux";
import { getTaskDriverGroups } from "../../store/actions/taskManager.action";
import DriverGroup from "../../components/settings/storage-summary/driverGroups";
import Header from "../../components/settings/storage-summary/Header";
import TaskManagerRequest from "../../services/TaskManagerRequest";
import { ShowNotification } from "../../services/Notifications";
import Loader from "../../components/UI/Loader";
import { getstartAndEndDateOfMonth } from "../../configs/duration";
import TabsLayout from "../../components/layouts/TabsLayout/TabsLayout";
import { Tab, TabList, TabPanel } from "react-tabs";
import VehiclesListPlaceHolder from "../../components/UI/placeholders/VehiclesListPlaceHolder";
import StorageCount from "../../components/settings/storage-summary/StorageCount";
import DriversStorageTable from "../../components/settings/storage-summary/DriversStorageTable";
import VehicleStorageTable from "../../components/settings/storage-summary/VehicleStorageTable";
import { loadVehicleStorage } from "../../store/actions/setting.action";
import VehicleGroup from "./../../components/settings/storage-summary/VehicleGroup";

const StorageSummary = () => {
  const dispatch = useDispatch();
  const [storageUsed, setStorageUsed] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [driversLoading, setDriversLoading] = useState(false);
  const [dates, setDates] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [storageDetails, setStorageDetails] = useState(null);
  const [activeVehicle, setActiveVehicle] = useState(null);

  const loadData = async (data = {}) => {
    try {
      setLoading(true);
      const response = await TaskManagerRequest("/storage/used", data);
      setStorageUsed(response);
    } catch (error) {
      ShowNotification("error", error);
    } finally {
      setLoading(false);
    }
  };

  const onChageMonth = (d) => {
    if (d == null) {
      setDates(false);
      loadData();
      return;
    }

    const datesObj = getstartAndEndDateOfMonth(d);
    setDates(datesObj);
    loadData(datesObj);
  };

  const loadInitialData = async () => {
    try {
      await dispatch(getTaskDriverGroups());
      dispatch(loadVehicleStorage());

      const response = await TaskManagerRequest("/storage/oldest-date", {});
      await loadStorageDetails();
      var data = {};
      if (response) {
        data = getstartAndEndDateOfMonth(new Date(response));
        setDates(data);
        loadData(data);
      } else {
        loadData(data);
      }
    } catch (error) {
      console.log("Error...", error);
    }
  };

  const loadStorageDetails = async () => {
    setStorageDetails(await TaskManagerRequest("/storage/details", {}));
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  const renderTabList = () => {
    return (
      <TabList style={{ gridTemplateColumns: "repeat(1, 1fr)" }}>
        <Tab>
          <div className="main-tab-chldrn selection-none">
            <img
              src={
                require("../../assets/img/settings/storage_active.png").default
              }
              width={15}
              className="mr-1"
            />
            <span>
              Storage Summary -{" "}
              {storageDetails?.storage?.usedSpace
                ? (storageDetails?.storage?.usedSpace / 1048576).toFixed(2)
                : "0"}{" "}
              GB
            </span>
          </div>
        </Tab>
      </TabList>
    );
  };

  const renderTabPanel = () => {
    return (
      <React.Fragment>
        <StorageCount
          activeTab={selectedIndex}
          setActiveTab={(i) => setSelectedIndex(i)}
          driversStorage={storageDetails?.driverStorage ?? 0}
          vehicleStorage={storageDetails?.vehicleStorage?.total ?? 0}
          setActiveVehicle={setActiveVehicle}
        />
        <TabPanel>
          {selectedIndex == 0 ? (
            <>
              {isLoading ? (
                <VehiclesListPlaceHolder type="driver" />
              ) : (
                <DriverGroup
                  storageUsed={storageUsed}
                  isLoading={driversLoading}
                  setLoading={setDriversLoading}
                />
              )}
            </>
          ) : (
            <VehicleGroup
              onVehicleSelected={setActiveVehicle}
              activeVehicle={activeVehicle}
              totalUsed={storageDetails?.vehicleStorage?.total}
            />
          )}
        </TabPanel>
      </React.Fragment>
    );
  };

  return (
    <Settings
      containerStyle={{ overflowY: "hidden" }}
      contentContainerStyle={{ overflowY: "hidden" }}
    >
      {driversLoading ? <Loader style={{ left: "14%" }} /> : <></>}
      <div className="row">
        <div className="col-md-4" style={styles.container}>
          <TabsLayout
            TabList={renderTabList()}
            TabPanel={renderTabPanel()}
            defaultFooterHeight={115}
          />
        </div>
        <div
          className="col-md-8 pl-0 visible-scroll-hover"
          style={styles.container2}
        >
          {selectedIndex == 0 ? (
            <>
              <Header
                onChageMonth={onChageMonth}
                dates={dates}
                heading={"Drivers Storage Summary"}
                showDatePicker={true}
              />
              <DriversStorageTable
                storageUsed={storageUsed}
                loadData={loadData}
                dates={dates}
              />
            </>
          ) : (
            <>
              <Header
                onChageMonth={onChageMonth}
                dates={dates}
                heading={"Vehicle Storage Summary"}
                showDatePicker={false}
              />
              <VehicleStorageTable
                activeVehicle={activeVehicle}
                storage={storageDetails}
                loadStorage={loadStorageDetails}
              />
            </>
          )}
        </div>
      </div>
    </Settings>
  );
};

const styles = {
  container: {
    height: "85vh",
    overflowY: "hidden",
    overflowX: "hidden",
  },
  container2: {
    height: "85vh",
    overflowY: "auto",
    overflowX: "hidden",
  },
};
export default StorageSummary;
